import { time } from 'highcharts';
import { compose } from 'redux';
import { weekToDate,toWeekStart } from '../helpers/calDate';

export const dateAndValue = (vibeObject, timeUnit, sdate, edate) => {
  // console.log('------------dateandvalues condition-----------------')
  // console.log(vibeObject, timeUnit, sdate, edate)
  // console.log('----------------------------------------------------')
  if (vibeObject) {
    // translate to {x: date, y: value} to fit the highchart auto date system
    
    let rawData = [];
    for (let date in vibeObject) {
      if (vibeObject.hasOwnProperty(date)) {
        let year = 0,
            month = 0,
            day = 0,
            week = 0;

        if (timeUnit==='glbtime_YM') {
          year = Number(date.substr(0, 4));
          month = Number(date.substr(4, 2)) - 1;
          day = 1;
        }
        else if (timeUnit==='glbtime_WEEKNUM') {
          const test = weekToDate(date);
          week = date.substr(0,4)+'-'+date.substr(4,6)+'w'
          year = Number(weekToDate(date).substr(0, 4));
          month = Number(weekToDate(date).substr(5, 2)) - 1;
          day = Number(weekToDate(date).substr(8, 2));
        }
        else {
          year = Number(date.substr(0, 4));
          month = Number(date.substr(4, 2)) - 1;
          day = Number(date.substr(6, 2));
        }
        rawData.push({
          // x: timeUnit==='glbtime_WEEKNUM' ? week : Date.UTC(year, month, day),
          x: Date.UTC(year, month, day),
          y: vibeObject[date],
          yearMoment: timeUnit==='glbtime_YM' ? year : null,
          monthMoment: timeUnit==='glbtime_YM' ? month+1 : null,
        })
      }
    }
    //20200722 修年線
    //20201203 (need to change) string.substr => substring

    let startDay = timeUnit==='glbtime_YM' ? 
      Date.UTC(
      Number(sdate.substr(0, 4)),
      Number(sdate.substr(4, 2)) - 1,
      1
    )
    : timeUnit ==='glbtime_WEEKNUM'
    ? toWeekStart(sdate) 
    : Date.UTC(
       Number(sdate.substr(0, 4)),
       Number(sdate.substr(4, 2)) - 1,
       Number(sdate.substr(6, 2))
     );
    
    let endDay = timeUnit ==='glbtime_WEEKNUM'
    ? toWeekStart(edate) 
    : Date.UTC(
        Number(edate.substr(0, 4)),
        Number(edate.substr(4, 2)) - 1,
        Number(edate.substr(6, 2)),
      );

    // add zero to null value date
    let timeConst = timeUnit==='glbtime_WEEKNUM' ? 7 : 1,
        startMoment = timeUnit==='glbtime_YM' ? [Number(sdate.substr(0, 4)), Number(sdate.substr(4, 2))] : null,
        endMoment = timeUnit==='glbtime_YM' ? [Number(edate.substr(0, 4)), Number(edate.substr(4, 2))] : null;

    let isLastDay = startDay === endDay,
        dayTick = 1000*60*60*24*timeConst,
        weekendTick = dayTick*(6/timeConst),
        resultData = [{x: startDay, y: 0}],
        endDayList = timeUnit==='glbtime_WEEKNUM' ? [{x: startDay+weekendTick, y: 0}] : null;
    // create new array with 0 values for each day
    // resultData.push({x: startDay, y: 0})

    while (!isLastDay) {
      if (timeUnit==='glbtime_YM') {
        if (startMoment[1]===12) {
          startMoment[0]++;
          startMoment[1] = 1;
        } else {
          startMoment[1]++;
        }

        let startDate_YM = Date.UTC(startMoment[0], startMoment[1]-1, 1)
        resultData.push({x: startDate_YM, y: 0})
        isLastDay =  startMoment[1] === endMoment[1] && startMoment[0] === endMoment[0] ? true : false;
      } else {
        startDay += dayTick;
        if (startDay > endDay) { // 不足一個禮拜
          resultData.push({x: endDay, y: 0})
        } else {
          resultData.push({x: startDay, y: 0})
          timeUnit==='glbtime_WEEKNUM' ? endDayList.push({x: startDay+weekendTick, y: 0}) : null
        }
        isLastDay = startDay >= endDay;
      }
      
    }

    //Override all values with existing days
    for (let i = 0; i < rawData.length; i++) {
      for(let j = 0; j < resultData.length; j++) {
          if (resultData[j].x == rawData[i].x) {
              resultData[j].y = rawData[i].y;
              break;
          }
      }
    }

    // fetch the sdate and edate
    if(timeUnit==='glbtime_WEEKNUM'){
      resultData[0].x=Date.UTC(Number(sdate.substr(0, 4)),Number(sdate.substr(4, 2)) - 1,Number(sdate.substr(6, 2)))

      // endDayList[endDayList.length-1].x=Date.UTC(Number(edate.substr(0, 4)),Number(edate.substr(4, 2)) - 1,Number(edate.substr(6, 2)))

      // const ans = []
      // endDayList.forEach((item,i)=>{
      //   let name = new Date(resultData[i].x).getFullYear()+'-'+(new Date(resultData[i].x).getMonth()+1)+'-'+new Date(resultData[i].x).getDate()+'~'+new Date(item.x).getFullYear()+'-'+(new Date(item.x).getMonth()+1)+'-'+new Date(item.x).getDate()
      //   ans.push({x: name,y:resultData[i].y})
      // })

      // resultData[resultData.length-1].x=Date.UTC(Number(edate.substr(0, 4)),Number(edate.substr(4, 2)) - 1,Number(edate.substr(6, 2)))
    }

    return resultData;
  }
  else {

    // If there is no field for any vibe, we add a field with all zero y-value
    let startDay = Date.UTC(
      Number(sdate.substr(0, 4)),
      Number(sdate.substr(4, 2)) - 1,
      Number(sdate.substr(6, 2)),
    );
    let endDay = Date.UTC(
      Number(edate.substr(0, 4)),
      Number(edate.substr(4, 2)) - 1,
      Number(edate.substr(6, 2)),
    );
    
    // add zero to null value date
    
    let timeConst = timeUnit==='glbtime_YMD' ? 1 : 7,
        startMoment = timeUnit==='glbtime_YM' ? [Number(sdate.substr(0, 4)), Number(sdate.substr(4, 2)) - 1] : null,
        endMoment = timeUnit==='glbtime_YM' ? [Number(edate.substr(0, 4)), Number(edate.substr(4, 2)) - 1] : null;

    let isLastDay = startDay === endDay,
        dayTick = 1000*60*60*24*timeConst,
        resultData = [];

    // create new array with 0 values for each day
    resultData.push({x: startDay, y: 0})

    while (!isLastDay) {
      if (timeUnit==='glbtime_YM') {
        if (startMoment[1]===12) {
          startMoment[0]++;
          startMoment[1] = 1;
        } else {
          startMoment[1]++;
        }

        let startDate_YM = Date.UTC(startMoment[0], startMoment[1], 1)
        resultData.push({x: startDate_YM, y: 0})
        isLastDay =  startMoment[1] === endMoment[1] && startMoment[0] === endMoment[0] ? true : false;
      }
      else {
        startDay += dayTick;
        if (startDay > endDay) { // 不足一個禮拜
          resultData.push({x: endDay, y: 0})
        } else {
          resultData.push({x: startDay, y: 0})
        }
        isLastDay = startDay >= endDay;
      }
    }
    

    console.log('all zero', {vibeObject, timeUnit, sdate, edate, resultData});
    
    return resultData;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/dateAndValue.js